import { useQuery } from '@tanstack/react-query';
import {
  listOffboardings,
  offboardingsListKey,
} from '../../services/offboardings';
import { ListOffboardingsParams } from '../../types/offboardings';

function useListOffboardings(
  params: ListOffboardingsParams,
  options: { enabled?: boolean } = {},
) {
  const enabled = options.enabled ?? true;
  return useQuery({
    queryKey: offboardingsListKey(params),
    queryFn: () => listOffboardings(params),
    enabled: enabled && !!params.businessId,
  });
}

export default useListOffboardings;
